import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { VwtechLibsApi } from './types';

export class VwtechLibsClient implements VwtechLibsApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async getLibrariesFile(_filename?: string): Promise<Blob> {
    const baseUrl = await this.discoveryApi.getBaseUrl('vwtech-libs');
    const response = await this.fetchApi.fetch(`${baseUrl}/libraries`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch library file: ${response.statusText}`);
    }
    
    return response.blob();
  }

  async getLandscapeFile(): Promise<{ blob: Blob; filename: string }> {
    const baseUrl = await this.discoveryApi.getBaseUrl('vwtech-libs');
    const response = await this.fetchApi.fetch(`${baseUrl}/landscape`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch landscape file: ${response.statusText}`);
    }

    const disposition = response.headers.get('Content-Disposition') ?? '';
    let filename = 'landscape.drawio';

    const match = /filename="?([^"]+)"?/i.exec(disposition);
    if (match && match[1]) {
      filename = match[1];
    }

    const blob = await response.blob();
    return { blob, filename };
  }
} 